import Vuetify from "@/plugins/vuetify";
import { ChartLinesColorsDark, Red } from "@/components/charts/ChartStyles";

/**
* @summary Cria um Json com os dados para formar o gráfico.
* @param {Array} chartData - Dados dos gráficos.
*/
const CreateChart = (chartData) =>
{
	const chart = [];

	for (let i = 0; i < chartData.length; i++)
	{
		if (chartData[i].isSetupOk)
		{
			const trace = {
				x:           chartData[i].xAxis,
				y:           chartData[i].yAxis,
				mode:        "lines",
				marker:      { color: ChartLinesColorsDark[i] },
				name:        chartData[i].name,
				frequencies: chartData[i].concernFrequencies,
			};

			chart.push(trace);
		}
	}
	return chart;
};

/**
 * @summary Cria marcações fixas e atribui na váriavel layout.
 * @param {Array} concernFrequencies Array com as posições do eixo x das anotações.
 * @return {Array} shapes - Linhas que serão incorporadas ao layout.
 */
const CreateAnnotations = (concernFrequencies) =>
{
	 const shapes = [];
	 for (let i = 0; i < concernFrequencies.length; i++)
	 {
		 const shape = {
			 yref: "paper",
			 type: "line",
			 x0:   concernFrequencies[i],
			 x1:   concernFrequencies[i],
			 y0:   0, // Representa 0%
			 y1:   1, // Representa 100%
			 line: {
				 color: Red,
				 width: 2,
				 dash:  "dot",
			 },
			 visible: false,
		 };
		 shapes.push(shape);
	 }
	 return shapes;
};

/**
 * @summary Cria as anotações e atribui na váriavel layout.
 * @param {Array} concernFrequencies Array com as posições do eixo x das anotações.
 * @param {Boolean} isDarkMode Indicador de utilização do dark mode.
 * @param {Array} annotationName Nome das anotações à serem incorporadas ao layout.
 * @return {Array} Annotations - Anotações que serão incorporadas ao layout.
 */
const CreateAnnotationText = (concernFrequencies, isDarkMode, annotationName) =>
{
	const annotations = [];
	for (let i = 0; i < concernFrequencies.length; i++)
	{
		// Seleciona a cor do texto
		const textColor = isDarkMode ? Vuetify.framework.theme.themes.dark.secondary :
			Vuetify.framework.theme.themes.light.info;

		// Cria o texto
		const text = `${i + 1}x ${annotationName}`;

		// Cria a anotação em texto.
		const annotation = {
			x:          concernFrequencies[i],
			y:          0.8, // 80 % do valor em Y
			yref:       "paper",
			mode:       "text",
			showlegend: false,
			text,
			showarrow:  false,
			visible:    false,
			textangle:  270,
			align:      "right",
			yanchor:    "top",
			xshift:     10,
			yshift:     30,
			font:       { color: textColor },
		};
		annotations.push(annotation);
	}
	return annotations;
};

export default {
	CreateChart,
	CreateAnnotations,
	CreateAnnotationText,
};
